import { render } from "./discuss_question_comment.vue?vue&type=template&id=3f6c4732&scoped=true"
import script from "./discuss_question_comment.vue?vue&type=script&lang=js"
export * from "./discuss_question_comment.vue?vue&type=script&lang=js"

import "./discuss_question_comment.vue?vue&type=style&index=0&id=3f6c4732&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6c4732"]])

export default __exports__